import StandardQueryTable from "@/components/StandardQueryTable";
import { Module } from "@/constants";
import { readContractorsPlannedHoursApproval } from "@/schemas/contractorsPlannedHoursApproval";
import { ReadContractorsPlannedHoursApproval } from "@/types/contractorsPlannedHoursApproval";
import { ContractorsPlannedHoursApprovalsService } from "../service";
import { useCallback, useMemo } from "react";
import { Filters } from "@/lib/filters";
import { ColumnSort } from "@tanstack/react-table";

const FIXED_SORT = "contractor_full_name,period,approved_at";
const name = "contractorsPlannedHoursApprovals";

const ContractorsPlannedHoursApprovalsList = () => {
  const fetchList = useCallback(
    (params: {
      lastItem: string | undefined;
      filters: Filters<ReadContractorsPlannedHoursApproval> | undefined;
      sorting: ColumnSort | undefined;
    }) =>
      ContractorsPlannedHoursApprovalsService.getList({
        lastItem: params.lastItem,
        filters: params.filters,
        queryParams: { sort: FIXED_SORT },
      }),
    [],
  );
  const tableFeatures = useMemo(
    () => ({
      enableSorting: false,
      exportSettings: {
        moduleName: Module.ContractorsPlannedHoursApprovals,
        queryParams: { sort: FIXED_SORT },
      },
    }),
    [],
  );

  return (
    <StandardQueryTable<ReadContractorsPlannedHoursApproval>
      schema={readContractorsPlannedHoursApproval}
      name={name}
      fetchList={fetchList}
      actions={[]}
      tableFeatures={tableFeatures}
    />
  );
};

export default ContractorsPlannedHoursApprovalsList;
